import { MOCK } from '../state/device';
import { state, getLeafletMap } from '../state/app-state';
import { trimCohort, isSelfCohortDevice, mergeCohortDevice, seedLocalDeviceInCohort } from '../state/cohort-model';
import { apiGetGroupRecent } from '../api/client';
import { refreshLiveBadges } from '../api/live-badge';
import { groupPathFor } from '../map/team-layer';
import { renderSessions } from '../ui/sidebar';
import { drawRoutes } from '../map/tracker';

export let groupPollTimer: any = null;
export let groupPollLastNow: number | null = null;
export function getGroupPollTimer(){ return groupPollTimer; }
export function resetGroupPollLastNow(){ groupPollLastNow = null; }
// The poll cursors on the server's `now`, but pings carry a
// client-supplied `t` that can lag `now` (fix-time latency, cross-device
// interleave, clock skew). Re-fetching a bounded overlap window each poll
// and leaning on dedupePings catches the common near-boundary misses the
// bare `since=last_now` cursor would drop.
const GROUP_POLL_OVERLAP_MS = 60_000;

export async function pollGroup(){
  if(document.hidden) return;          // F1: skip hidden-tab ticks (re-show catches up)
  if(!MOCK.device) return;
  const path = groupPathFor(MOCK.device.group);
  if(!path) return;
  let data;
  try {
    const since = groupPollLastNow != null
      ? Math.max(0, groupPollLastNow - GROUP_POLL_OVERLAP_MS)
      : null;
    data = await apiGetGroupRecent(path, since);
  } catch (err) {
    console.warn('[locus] cohort poll failed', err);
    return;
  }
  if(data == null){
    // 404 — cohort is empty server-side. Still show the local row.
    state.cohort.clear();
    seedLocalDeviceInCohort();
  } else {
    for(const dev of data.devices){
      if(isSelfCohortDevice(dev)) continue;   // own echo — seeded separately below
      mergeCohortDevice(dev);
    }
    seedLocalDeviceInCohort();
    groupPollLastNow = data.now;
  }
  trimCohort();
  // Optional lens live badge (spec Phase 4 / §7): fire-and-forget, fail-open.
  // Off unless built with VITE_LENS_BADGE=1. We DON'T await it — the cohort
  // render below proceeds immediately; the badge eventually-consistently
  // appears on the next render once this resolves (the badge mutates only its
  // own module state, never this poll's data path). Errors are swallowed inside.
  refreshLiveBadges(path)
    .then(() => { if(state.viewMode === 'devices') renderSessions(); })
    .catch(() => { /* fail-open: never disturb the cohort render */ });
  if(state.viewMode === 'devices'){
    renderSessions();
    if(getLeafletMap()) drawRoutes();
  }
}

export function startGroupPoll(){
  if(groupPollTimer) return;          // idempotent
  pollGroup();                        // fire immediately
  groupPollTimer = setInterval(pollGroup, 30_000);
}

export function stopGroupPoll(){
  if(groupPollTimer){ clearInterval(groupPollTimer); groupPollTimer = null; }
  groupPollLastNow = null;
}

export function startCohortLive(){
  if(state.viewMode !== 'devices') return;
  if(!MOCK.device || !groupPathFor(MOCK.device.group)) return;
  // startGroupPoll fires pollGroup() immediately, so the list paints on
  // the first poll and refreshes every 30 s thereafter.
  startGroupPoll();
}

export function stopCohortLive(){
  stopGroupPoll();
}
